module.exports = {
  METHODS: {
    post: {
      key: 'post',
      label: 'Create',
    },
    put: {
      key: 'put',
      label: 'Update',
    },
    get: {
      key: 'get',
      label: 'Get',
    },
    delete: {
      key: 'delete',
      label: 'Delete',
    },
  },
  AUTH_TYPES: {
    refresh: {
      key: 'refresh',
      label: 'Refresh Token',
    },
    noAuth: {
      key: 'noAuth',
      label: 'No Auth Token Required',
    },
    idToken: {
      key: 'idToken',
      label: 'Id Token',
    },
  },
  GATEWAY_TYPES: {
    rest: {
      key: 'rest',
      label: 'Rest API Gateway'
    },
    websocket: {
      key: 'websocket',
      label: 'Websocket API Gateway'
    }
  },
  HEADER_CONTENT_TYPES: {
    json: {
      key: 'json',
      label: 'JSON',
    },
    multipartFormData: {
      key: 'multipartFormData',
      label: 'Multi-part form data'
    },
  },
};